import * as React from 'react';
import { XIcon } from '@heroicons/react/solid';
import Modal from 'components/Modal/HeadlessUiModal';
import PermissionedBlock from 'components/PermissionedBlock';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  /** Copy for the block; omitted props fall back to PermissionedBlock's default pitch. */
  title?: string;
  buttonText?: string;
  description?: React.ReactNode;
}

/**
 * The dashboard's in-context upsell: a compact dialog around PermissionedBlock. One component so
 * every locked feature on a screen (dark pool levels, historical flow, ...) opens the same door.
 */
export default function SubscribeModal({ isOpen, onClose, title, buttonText, description }: Props) {
  return (
    // Named by its title: without it a screen reader announced only "dialog".
    <Modal isOpen={isOpen} handleClose={onClose} ariaLabel={title || 'Subscribe'}>
      <div className="relative rounded-lg bg-palette-black-1 p-4">
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="absolute right-2 top-2"
        >
          <XIcon className="w-5" />
        </button>
        <PermissionedBlock title={title} buttonText={buttonText} description={description} />
      </div>
    </Modal>
  );
}
